import { Transform } from 'class-transformer';
import { IsEmail, IsNotEmpty, IsString, Matches, MaxLength, MinLength } from 'class-validator';

export class RegisterRequestDto {
    @IsNotEmpty()
    @IsEmail()
    @Transform(({ value }: { value: string }) => value.toLowerCase())
    email: string;

    @IsNotEmpty()
    @IsString()
    @MinLength(12, { message: 'Password must be at least 12 characters long' })
    @MaxLength(100, { message: 'Password must be at most 100 characters long' })
    @Matches(/[A-Z]/, { message: 'Password must contain at least one uppercase letter' })
    @Matches(/\d/, { message: 'Password must contain at least one digit' })
    @Matches(/[^A-Za-z0-9]/, { message: 'Password must contain at least one special character' })
    password: string;
}
